import comp from "./TagCell";
export default comp;
